// components/strategy/StrategyAdministrationPanel.jsx — Phase 3B
// super_admin-only sub-view (account management + audit log). An
// `admin`-role account sees a clear message instead — the SERVER
// already rejects every one of these calls for a non-super_admin
// (403), this is purely a friendlier client-side short-circuit.
import React, { useState } from "react";
import { strategyAuth } from "../../lib/strategyAuth";
import { StrategyAccountsPanel } from "./StrategyAccountsPanel";
import { StrategyAuditPanel } from "./StrategyAuditPanel";

export const StrategyAdministrationPanel = () => {
  const session = strategyAuth.get();
  const [tab, setTab] = useState("comptes");

  if (!session || session.activeRole !== "super_admin") {
    return (
      <div className="text-xs text-zinc-400 p-4" data-testid="strategy-admin-forbidden">
        Réservé au Super Administrateur du pays actif ({session?.activeCountryCode}).
      </div>
    );
  }

  return (
    <div className="p-4 max-w-xl" data-testid="strategy-administration-panel">
      <div className="flex gap-2 mb-3">
        <button data-testid="strategy-admin-tab-comptes" onClick={() => setTab("comptes")}
          className={`text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1 border-2 ${tab === "comptes" ? "border-rescue-red text-rescue-red" : "border-transparent text-zinc-400"}`}>
          Comptes
        </button>
        <button data-testid="strategy-admin-tab-audit" onClick={() => setTab("audit")}
          className={`text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1 border-2 ${tab === "audit" ? "border-rescue-red text-rescue-red" : "border-transparent text-zinc-400"}`}>
          Journal d'audit
        </button>
      </div>
      {tab === "comptes" ? <StrategyAccountsPanel countryCode={session.activeCountryCode} /> : <StrategyAuditPanel countryCode={session.activeCountryCode} />}
    </div>
  );
};
